import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles(({ spacing, palette }) => ({
  root: {
    width: "512px",
    backgroundColor: palette.otherElementsBackground.main,
    color: palette.contrastText.main,
    borderColor: palette.separator.main,
    padding: spacing(2, 3),
  },
  modalTitle: {
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "150%",
  },
  modalSubtitle: {
    fontSize: "14px",
    lineHeight: "150%",
    color: grey[600],
  },
  closeButton: {
    marginTop: spacing(2),
    padding: spacing(0.25, 0),
  },
}));
